/* global Swal */

/**
 * O selo de assinatura digital é desenhado dentro do PDF, antes de assinar:
 * assinar sela os bytes do arquivo, então não há como carimbar depois.
 *
 * Quem gerou escolhendo "não quero assinar digitalmente" e depois muda de ideia
 * assina um arquivo que já existe — a assinatura vale, mas o documento sai sem
 * o selo e sem o registro no rodapé. Avisar é melhor que surpreender: o
 * profissional decide entre assinar assim mesmo ou reabrir e gerar de novo.
 *
 * @returns {Promise<boolean>} false quando o profissional desiste.
 */
export async function confirmarAssinaturaSemSelo({generated, signed, certifier}) {
  const vaiAssinar = !!certifier?.id && certifier.id !== 'none';

  if (!vaiAssinar || generated !== true || signed === true) {
    return true;
  }

  const result = await Swal.fire({
    title: 'Documento já gerado sem assinatura',
    html: 'Este documento foi gerado com a opção <b>“Não quero assinar digitalmente”</b>.'
      + '<br><br>Ele será assinado normalmente e a assinatura tem validade, mas <b>sai sem o selo</b>'
      + ' e sem o registro da assinatura no rodapé — eles são desenhados antes de assinar, e o arquivo já existe.'
      + '<br><br>Para sair com o selo é preciso <b>reabrir</b> e gerar de novo.'
      + ' Em receituário controlado, reabrir consome uma numeração nova do SNCR.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Assinar assim mesmo',
    cancelButtonText: 'Cancelar',
    confirmButtonColor: '#780f5a',
  });

  return result.isConfirmed === true;
}
